import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = React.createElement("path", { d: "M13 2h-2v9H2v2h9v9h2v-9h9v-2h-9V2z" });
export default createSvgIcon(iconPath, "Plus");
//# sourceMappingURL=PlusIcon.js.map